/*
  Ported from src/pages/ProductPage.tsx — gallery thumbnail switch, qty stepper,
  and add-to-cart via Shopify's Ajax Cart API (/cart/add.js). Replaces the old
  fake-localStorage cart's handleAdd() with a real cart write.
*/
(function () {
  function initGallery(root) {
    var mainImg = root.querySelector('[data-pdp-main-image]');
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full-src');
        if (mainImg && src) mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-pdp-qty-input]');
    var minus = root.querySelector('[data-pdp-qty-minus]');
    var plus = root.querySelector('[data-pdp-qty-plus]');
    if (!input) return;

    minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
    plus.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  }

  function initAddToCart(root) {
    var button = root.querySelector('[data-pdp-add-to-cart]');
    if (!button) return;
    var variantId = button.getAttribute('data-variant-id');
    var qtyInput = root.querySelector('[data-pdp-qty-input]');
    var label = button.querySelector('oblivion-descramble');
    var defaultText = label ? label.textContent : '';

    button.addEventListener('click', function () {
      if (button.disabled) return;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-to-cart failed');
          return res.json();
        })
        .then(function () {
          button.classList.add('is-added');
          if (label) label.textContent = 'AJOUTÉ AU PANIER';
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          setTimeout(function () {
            button.classList.remove('is-added');
            if (label) label.textContent = defaultText;
          }, 1800);
        })
        .catch(function () {
          if (label) label.textContent = 'ERREUR — RÉESSAYER';
          setTimeout(function () {
            if (label) label.textContent = defaultText;
          }, 1800);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-pdp]').forEach(function (root) {
      initGallery(root);
      initQuantity(root);
      initAddToCart(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
